export default class Homework {
  constructor({
    id = null,
    title = '',
    description = '',
    release_date = '',
    file_paths = [],
    semester_id = null,
    teacher_id = null,
    created_at = '',
    updated_at = '',
    files_metadata = [],
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.release_date = release_date;
    this.file_paths = file_paths;
    this.semester_id = semester_id;
    this.teacher_id = teacher_id;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.files_metadata = files_metadata;
  }

  // Basic validation for homework data
  static validate(homeworkData) {
    if (!homeworkData.title) {
      throw new Error('Title is required');
    }
    if (!homeworkData.description) {
      throw new Error('Description is required');
    }
    if (!homeworkData.release_date) {
      throw new Error('Release date is required');
    }
    if (!homeworkData.semester_id) {
      throw new Error('Semester ID is required');
    }
    if (!homeworkData.teacher_id) {
      throw new Error('Teacher ID is required');
    }
  }

  // Format date to DD.MM.YYYY
  static formatDate(datetime) {
    const date = new Date(datetime);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  static formatDateForInput(date) {
    return date ? date.split('T')[0] : '';
  }
}

export class HomeworkWithRelatedData extends Homework {
constructor({
  teacher = null,
  semester = null,
  subtasks = [],
  deadlines = [],
  ...homeworkData
}) {
  super(homeworkData);
  this.teacher = teacher;
  this.semester = semester;
  this.subtasks = subtasks;
  this.deadlines = deadlines;
}
}

export class HomeworkWithTeacherAndSemester extends Homework {
  constructor({
    teacher = null,
    semester = null,
    ...homeworkData
  }) {
    super(homeworkData);
    this.teacher = teacher;
    this.semester = semester;
  }
}